// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2700":"988ca09b","3395":"55ac9546","3960":"968c581b","5283":"1d5199b8","7228":"e5ffc0ed"}[chunkId] + ".chunk.css";
};